// src/supabase.js
import { createClient } from '@supabase/supabase-js';

// Read the values from .env file
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Test connection (optional - remove after testing)
console.log('Supabase client initialized with URL:', supabaseUrl);